import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MpJobOfferCreateComponent } from "./mp-job-offer-create.component";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { NzSpaceModule } from "ng-zorro-antd/space";
import { NzWaveModule } from "ng-zorro-antd/core/wave";
import { RouterLink } from "@angular/router";
import { MpJobOfferFormModule } from "../mp-job-offer-form/mp-job-offer-form.module";
import {NzGridModule} from "ng-zorro-antd/grid";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [MpJobOfferCreateComponent],
    imports: [
        CommonModule,
        MpJobOfferFormModule,
        NzButtonModule,
        NzPageHeaderModule,
        NzSpaceModule,
        NzWaveModule,
        RouterLink,
        NzGridModule,
        TranslateModule,
    ],
})
export class MpJobOfferCreateModule {}
